import { ReactElement, useContext, useEffect } from "react";

import AuthTransactionContext from "pages/register/contexts/AuthTransactionContext";

import PageLoading from "global-components/pageLoading/PageLoading";
import ErrorPage from "global-components/errorPage/ErrorPage";

import useGetAuthorizeUrl from "pages/register/hooks/useGetAuthorizeUrl";

import getAuthorizeParams from "pages/register/util/getAuthorizeParams";
import { getRegistrationData } from "pages/register/util/registrationDataManager";

// Historically, this step of the flow rendered a confirmation page, and redirecting to Okta required the user to click a button.
// Now this component will automatically redirect the user to Okta.
// There's a required request to the BFF to get the redirect URL, so this component still needs to render the loading screen in the meantime.
const CompleteRegistrationContainer = (): ReactElement => {
  const { username, sessionToken } = getRegistrationData();
  const { completeRegistration } = useContext(AuthTransactionContext);

  const { data: authorizeData, isLoading: isLoadingRedirectUrl } =
    useGetAuthorizeUrl({
      ...getAuthorizeParams(),
      sessionToken,
    });

  useEffect(() => {
    if (authorizeData?.redirectUrl) {
      completeRegistration(authorizeData.redirectUrl);
    }
  }, [authorizeData, completeRegistration]);

  if (isLoadingRedirectUrl || authorizeData?.redirectUrl) {
    return <PageLoading />;
  }

  console.log({
    message:
      "User is supposed to be redirected at this point, but the url is missing required query parameters.",
    pageUrl: window.location.href,
    username,
  });

  return <ErrorPage />;
};

export default CompleteRegistrationContainer;
